// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1dbfe598","239":"9af712b5","453":"bd14f3c0","732":"3e744df8"}[chunkId] + ".chunk.js";
};